module.exports = __webpack_public_path__ + "static/media/pbradshaw.9db11592.jpg";